#@import Backbone
#@import DealCarousel.CarouselTemplate
#@export DealCarousel.View

TABLET_MQ_WIDTH = 768
IMAGE_ASPECT_RATIO = 0.6

window.DealCarousel ?= {}

DealCarousel.View = Backbone.View.extend
  events:
    'click .gallery-control-back':      'onBackClick'
    'click .gallery-control-forward':   'onForwardClick'
    'click .gallery-control-left':      'onLeftClick'
    'click .gallery-control-right':     'onRightClick'
    'click .gallery-thumbnail':         'onThumbnailClick'

  initialize: ->
    @$el ?= $(@el)
    @currentFeatured = @options.featured || @collection.first()
    @collection.classes = ''
    @collection.view = this
    @collection.videoBHD = JSON.stringify video: true
    @collection.featured = =>
      @currentFeatured
    @collection.uuid = @options.uuid
    @collection.renderFullCarousel = @collection.length > 1
    @collection.showThumbs = @options.showThumbs
    @collection.showProductSizing = @options.showProductSizing
    @collection.compareSizeMessage = @options.compareSizeMessage if @options.showProductSizing
    @collection.lazyLoadThumbs = @options.lazyLoadThumbs
    @collection.lazyLoadFeatured = @options.lazyLoadFeatured
    @collection.featuredImageThumbnail = @options.featuredImageThumbnail
    @collection.featuredImageLowQuality = @options.featuredImageLowQuality
    @options.imageQualty ?= ''

  render: ->
    @$el = $(@el)
    @$body = $(document.body)
    @rtl = @$body.hasClass 'rtl'

    renderOptions = _.extend {zoomMessage: @options.zoomMessage, showRTL: @rtl}, @collection
    el = DealCarousel.CarouselTemplate.render(renderOptions)
    @$el = $(el).replaceAll(@$el)
    @el = @$el[0]
    @$thumbs = @$el.find(".gallery-thumbs")
    @$thumbnails = @$thumbs.children()
    @$gallery = @$el.find(".gallery-featured")
    @$galleryMedia = @$gallery.find("img")
    @$gallerySleepyMedia = @$gallery.find(".featured-image.sleepy-load")
    @$clickBlocker = @$el.find(".click-blocker")
    @$controls = @$el.find(".gallery-controls")
    @$backButton = @$controls.find(".gallery-control-back")
    @$forwardButton = @$controls.find(".gallery-control-forward")
    @$leftButton = @$controls.find(".gallery-control-left")
    @$rightButton = @$controls.find(".gallery-control-right")
    @containerWidth = @$el.width()
    @insideContainerWidth = @containerWidth - @$backButton.width() - @$forwardButton.width()

    @animateViaJS = !@$body.parent('html').hasClass 'cssanimations'

    @thumbsWidth = @$thumbs.width()
    @thumbWidth = @$thumbs.children().outerWidth()

    if @rtl
      @thumbMargin = parseInt(@$thumbs.children().css("margin-left"))

    else
      @thumbMargin = parseInt(@$thumbs.children().css("margin-right"))

    @thumbsWidth = @_calculateThumbsWidth()
    @media = {}
    @currentPosition = 0
    @hasOverflow = @thumbsWidth > @containerWidth

    # TODO non chrome browsers are returning non zero value for media height. added additional check for sleepy load
    isSleepyLoadedMediaPresent = @$gallerySleepyMedia.length or @$gallerySleepyMedia.length

    if @options.mediaHeight < @$galleryMedia.height() or @$galleryMedia.height() is 0 or isSleepyLoadedMediaPresent
      bodyWidth = @$body.width()
      if bodyWidth > TABLET_MQ_WIDTH
        @setFeaturedHeight(@options.mediaHeight)
      else
        height = IMAGE_ASPECT_RATIO * @containerWidth
        @setFeaturedHeight(height)

    else
      @setFeaturedHeight(@$galleryMedia.height())

    @centerThumbs()
    featuredIndex = @collection.indexOf(@currentFeatured)
    @fetchInitialMedia(featuredIndex) unless @options.featuredImageLowQuality or @options.lazyLoadFeatured

    @_prepareGroups()
    @_adjustThumbs(featuredIndex) unless featuredIndex is 0

    @delegateEvents()

  centerThumbs: ->
    @thumbsWidth = @_calculateThumbsWidth()
    @$thumbs.width(@thumbsWidth)

    if !@hasOverflow
      @visibleThumbs = @$thumbnails.length

    else
      direction = if @rtl then 'right' else 'left'
      @visibleThumbs = Math.floor(@insideContainerWidth / @thumbWidth)
      @visibleThumbs--
      @$el.addClass("has-navigation")
      @$thumbs.css(direction, @$backButton.width() + @thumbMargin)

  fetchMedia: (index) ->
    media = @collection.at(index)
    return false if @media[media.id]?
    if media.type is "video"
      @fetchVideo(media)
    else
      @fetchImage(media)

  fetchImage: (image) ->
    newImage = new Image()
    newImage.src = image.media
    $newImage = $(newImage)
    $newImage.data("id", image.id)
    $newImage.attr("id", "gallery-image-#{image.id}")
    $newImage.attr("alt", image.alt) if image.alt?
    @media[image.id] = $newImage

  fetchVideo: (video) ->
    playerId = if video.provider is "KALTURA"
      "kaltura-player-1360194818"
    else if video.provider is "OOYALA"
      "ooyala-player"
    else if video.provider is "YOUTUBE"
      "yt-player"

    @media[video.id] = $("<div/>", { id: "video-container" })
    .attr("data-bhw","PromNightVideo")
    .html("<div id=\"#{playerId}\" style=\"width:#{@containerWidth}px; height:#{@options.mediaHeight}px; margin: 0 auto;\"></div>")

  fetchInitialMedia: (start = 0) ->
    loadCount = 1

    if @options.prefetchImages
      collectionSize = @collection.size()
      loadCount = @visibleThumbs
      loadCount = collectionSize - start if start + loadCount > collectionSize

    @fetchMedia(i) for i in [start...start + loadCount]

  onBackClick: (e, skipRtlCheck = false) ->
    return unless @hasOverflow
    unless skipRtlCheck
      return @onForwardClick(null, true) if @rtl

    if @activeGroup > 0
      @activeGroup--
    else
      @activeGroup = @totalGroups - 1

    @_updateThumbsPosition()

  onForwardClick: (e, skipRtlCheck = false) ->
    return unless @hasOverflow
    unless skipRtlCheck
      return @onBackClick(null, true) if @rtl

    if @activeGroup < @totalGroups - 1
      @activeGroup++
    else
      @activeGroup = 0

    @_updateThumbsPosition()

  onLeftClick: (e, skipRtlCheck = false) ->
    unless skipRtlCheck
      return @onRightClick(null, true) if @rtl

    currentThumb = @collection.indexOf(@currentFeatured)
    if currentThumb > 0
      newMedia = @collection.at(currentThumb - 1)
      @updateGallery(newMedia)

    else
      newMedia = @collection.at(@collection.size() - 1)
      @updateGallery(newMedia)

    @_setActiveGroup()

  onRightClick: (e, skipRtlCheck = false) ->
    unless skipRtlCheck
      return @onLeftClick(null, true) if @rtl

    currentThumb = @collection.indexOf(@currentFeatured)
    if currentThumb < @collection.size() - 1
      newMedia = @collection.at(currentThumb + 1)
      @updateGallery(newMedia)

    else
      newMedia = @collection.at(0)
      @updateGallery(newMedia)

    @_setActiveGroup()

  onThumbnailClick: (e) ->
    $thumb = @$thumbs.find(e.currentTarget)
    newMedia = @collection.get($thumb.data("id"))

    return unless newMedia != @currentFeatured
    @updateGallery(newMedia)

  playVideo: (media) ->
    if media.provider is "KALTURA"
      kWidget.embed
        "targetId": "kaltura-player-1360194818"
        "cache_st": 1360194818
        "wid": "_1302621"
        "uiconf_id": "11486911"
        "flashvars":
          "autoPlay": true
          "streamerType": "hdnetwork"
          "akamaiHD":
            "loadingPolicy": "preInitialize"
            "asyncInit": "true"
        "entry_id": media.media
    else if media.provider is "OOYALA"
      @videoPlayer = OO.Player.create 'ooyala-player', media.media,
        autoplay: true
    else if media.provider is "YOUTUBE"
      @videoPlayer = new YT.Player 'yt-player',
        height: @$el.height()
        width: @$el.width()
        videoId: media.media
        playerVars:
          'rel': 0,
          'showinfo': 0
        events:
          onReady: (e) ->
            e.target.playVideo()

  setFeaturedHeight: (mediaHeight) ->
    @$gallery.height(mediaHeight)
    mediaHeight += 3 unless @$body.hasClass("goods") or @$body.hasClass("getaways") or @$body.hasClass("getaways-booking")
    @$controls.height(mediaHeight)

  updateGallery: (newMedia) ->
    newMediaIndex = @collection.indexOf(newMedia)

    if @media[newMedia.id]
      newGalleryMedia = @media[newMedia.id]
    else
      @fetchMedia(newMediaIndex)
      newGalleryMedia = @media[newMedia.id]

    $newGalleryMedia = $(newGalleryMedia)

    if @animateViaJS
      transitionCSS =
        opacity: 0

      $newGalleryMedia.css(transitionCSS)

    $newGalleryMedia.appendTo(@$gallery)

    if newMediaIndex > 0
      @$leftButton.removeClass("disabled")
    else
      @$leftButton.addClass("disabled")

    if newMediaIndex < @collection.size() - 1
      @$rightButton.removeClass("disabled")
    else
      @$rightButton.addClass("disabled")

    @_adjustThumbs(@collection.indexOf(newMedia))

    if newMedia.type is "video"
      @playVideo(newMedia)
      @$clickBlocker.hide()
      @$controls.hide()
    else
      @$clickBlocker.show()
      @$controls.show()

    isCurrentVideo = @currentFeatured.type is "video"

    onComplete = =>
      @$gallery.children("[id^='gallery-']:not(#gallery-video-#{@currentFeatured.id}, #gallery-image-#{@currentFeatured.id})").remove()
      if isCurrentVideo
        @videoPlayer?.destroy()
        @$gallery.children("#video-container").remove()

    if @animateViaJS
      transitionCSS =
        opacity: 1

      $newGalleryMedia.animate(transitionCSS,{ complete: onComplete},"slow")

    else
      setTimeout onComplete, 600

    @$thumbs.find("#gallery-thumb-#{newMedia.id}").addClass("selected").siblings().removeClass("selected")
    @$galleryMedia = $newGalleryMedia
    @currentFeatured = newMedia
    @$body.trigger "carouselUpdate",
      image: newMedia.baseURL
      uuid: @options.uuid

  updateCollection: (@collection) ->
    return unless @collection
    singleImage = @collection.length is 1
    currentHeight = @$el.height() if singleImage
    @undelegateEvents
    @collection.uuid = @options.uuid
    @collection.renderFullCarousel = !singleImage
    @currentFeatured = @collection.first()
    @render()

    @$el.css("min-height", currentHeight) if singleImage

  _calculateThumbMargins: (marginalia) ->
    if @visibleThumbs > 1
      return Math.floor(marginalia / (@visibleThumbs - 1))
    else
      Math.floor(marginalia)

  _calculateThumbsWidth: ->
    (@thumbWidth + @thumbMargin) * @$thumbnails.length - @thumbMargin

  _prepareGroups: ->
    @thumbGroups = []
    @totalGroups = 0
    @thumbsPerGroup = 0
    @activeGroup = 0
    @pnThumbWidth = @thumbWidth + @thumbMargin
    @pnThumbWrapWidth = @$thumbnails.length * @pnThumbWidth

    if @hasOverflow
      @_setThumbsPerGroup()
      @_setTotalGroups()
      @_setThumbGroups()
      @_setLastGroupThumbsShort()
      @_setActiveGroup()
      @_updateThumbsPosition()

  _scrollThumbsPosition: ->
    direction = if @rtl then 'right' else 'left'
    options = {}
    options[direction] = -1 * $(@$thumbnails[@currentPosition]).position()[direction] + @$backButton.width()

    if @animateViaJS
      @$thumbs.animate options

    else
      @$thumbs.css options

    if @currentPosition is 0
      @$backButton.addClass "disabled"
    else
      @$backButton.removeClass "disabled"

    if @currentPosition is @collection.size() - @visibleThumbs
      @$forwardButton.addClass "disabled"
    else
      @$forwardButton.removeClass "disabled"

  _setActiveGroup: ->
    currentIndex = @collection.indexOf(@currentFeatured)
    lastRange = @thumbGroups[@totalGroups - 1]

    for group, i in @thumbGroups
      if currentIndex >= group[0] and currentIndex <= group[1]
        if @activeGroup isnt i
          @activeGroup = i
          @_updateThumbsPosition()

  _setLastGroupThumbsShort: ->
    @thumbsShort = @thumbsPerGroup - (@thumbGroups[@totalGroups - 1][1] - @thumbGroups[@totalGroups - 1][0] + 1)

  _setThumbGroups: ->
    for i in [0..@totalGroups - 1]
      start = i * @thumbsPerGroup
      end = start + @thumbsPerGroup - 1

      if end >= @$thumbnails.length
        end = @$thumbnails.length - 1

      @thumbGroups[i] = [start, end]

  _setThumbsPerGroup: ->
    @thumbsPerGroup = Math.floor(@insideContainerWidth / (@thumbWidth + @thumbMargin))

  _setTotalGroups: ->
    @totalGroups = Math.ceil(@thumbsWidth / @insideContainerWidth)

  _updateThumbsPosition: ->
    modifier = 0

    if @activeGroup is @totalGroups - 1
      modifier = (@thumbWidth + @thumbMargin) * @thumbsShort

    direction = if @rtl then 'right' else 'left'
    options = {}
    options[direction] = "#{-1 * (((@insideContainerWidth - @thumbMargin) * @activeGroup) - modifier - @$backButton.width() - @thumbMargin)}px"

    if @animateViaJS
      @$thumbs.animate options

    else
      @$thumbs.css options

  _adjustThumbs: (index) ->
    for group, i in @thumbGroups
      if index >= group[0] and index <= group[1] and @activeGroup isnt i
        @activeGroup = i
        @_updateThumbsPosition()
        @fetchMedia(i) for i in [group[0]..group[1]]
        break

    return

